import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { ImportRequest } from '../../shared/models';
import { getImportRequests } from '../../admin-store/admin.selectors';
import {
  ClearAdminImportRequestsAction,
  LoadAdminImportRequestsAction
} from '../../admin-store';

@Component({
  templateUrl: './admin-import-requests.component.html',
  styleUrls: ['./admin-import-requests.component.scss'],
  standalone: false
})

export class AdminImportRequestsComponent implements OnInit, OnDestroy {

  importRequests$: Observable<ImportRequest[]>;

  constructor(private store: Store<AppState>) {
    this.importRequests$ = this.store.pipe(select(getImportRequests));
  }

  ngOnInit() {
    this.store.dispatch(new LoadAdminImportRequestsAction());
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearAdminImportRequestsAction());
  }
}
